package stocking;


enum SceneTransitionState {
	None;
	Preloading;
	Exiting;
	Done;
}

class SceneManager
{

	public static var instance(default, null):SceneManager = new SceneManager();

	private var scenes = new Array<Scene>();
	private var currentScene : Scene = null;
	private var nextScene : Scene = null;

	public function new()
	{
		
	}

	public function hasNextScene()
	{
		return nextScene != null;
	}


	public function transitionToScene( other : Scene )
	{
		nextScene = other;
		other.preload();
		if( currentScene != null )
			currentScene.exit();
		else
			trace("No current scene. Sorry ");
	}

	public function tick( delta : Float )
	{
		if( hasNextScene() )
		{
			if( nextScene.get_loaded() )
			{
				if( currentScene == null || currentScene.get_exited() )
				{
					currentScene = nextScene;
					currentScene.enter();
				}
			}
		}

		if( currentScene != null )
			currentScene.tick(delta);

	}


}